import React from 'react';
import Icon from '../../../components/AppIcon';

const FinancialHealthScore = ({ score, recommendations }) => {
  const getScoreColor = (score) => {
    if (score >= 80) return { bg: 'bg-success', text: 'text-success', ring: 'ring-success' };
    if (score >= 60) return { bg: 'bg-primary', text: 'text-primary', ring: 'ring-primary' };
    if (score >= 40) return { bg: 'bg-warning', text: 'text-warning', ring: 'ring-warning' };
    return { bg: 'bg-error', text: 'text-error', ring: 'ring-error' };
  };

  const getScoreLabel = (score) => {
    if (score >= 80) return 'Excellent';
    if (score >= 60) return 'Good';
    if (score >= 40) return 'Fair';
    return 'Needs Improvement';
  };

  const colors = getScoreColor(score);
  const circumference = 2 * Math.PI * 70;
  const strokeDashoffset = circumference - (score / 100) * circumference;

  return (
    <div className="bg-card border border-border rounded-xl p-6">
      <h3 className="text-lg font-semibold text-foreground mb-6">Financial Health Score</h3>
      <div className="flex flex-col items-center mb-6">
        <div className="relative w-48 h-48">
          <svg className="transform -rotate-90 w-48 h-48">
            <circle
              cx="96"
              cy="96"
              r="70"
              stroke="#E5E7EB"
              strokeWidth="12"
              fill="none"
            />
            <circle
              cx="96"
              cy="96"
              r="70"
              stroke="currentColor"
              strokeWidth="12"
              fill="none"
              strokeDasharray={circumference}
              strokeDashoffset={strokeDashoffset}
              strokeLinecap="round"
              className={`${colors?.text} transition-all duration-1000`}
            />
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <span className="text-4xl font-bold text-foreground">{score}</span>
            <span className="text-sm text-muted-foreground">out of 100</span>
            <span className={`text-sm font-medium ${colors?.text} mt-1`}>{getScoreLabel(score)}</span>
          </div>
        </div>
      </div>
      <div className="space-y-3">
        <h4 className="text-sm font-semibold text-foreground mb-3">Personalized Recommendations</h4>
        {recommendations?.map((rec, index) => (
          <div key={index} className="flex items-start gap-3 p-3 bg-muted/50 rounded-lg">
            <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name={rec?.icon} size={16} className="text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground mb-1">
                {rec?.title}
              </p>

              {rec?.description ? (
                <p className="text-xs text-muted-foreground">
                  {rec.description}
                </p>
              ) : null}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FinancialHealthScore;